import { useGlobalState } from '@/hooks';
import { ShipmentSelector } from '@/modules/pmt/components/ShipmentSelector';
import { FILTER_OPTIONS, MAPPED_TRANSLATION_FILTER_OPTIONS } from '@/modules/pmt/constants';
import { useShipmentFiltersContext, useShipmentsOverviewContext } from '@/modules/pmt/context';
import { gtmClickFilter } from '@/utils';
import FilterIcon from '../../../../../../../public/images/icons/tune.svg';
import { FilterChip } from '../FilterChip';

export const ShipmentFilter = () => {
  const { t } = useGlobalState();
  const { filterConfig, updateCurrentFilter } = useShipmentFiltersContext();
  const { shipmentsQty } = useShipmentsOverviewContext();

  const translatedFilterOptions = Object.values(FILTER_OPTIONS).map((value) => ({
    label: t(MAPPED_TRANSLATION_FILTER_OPTIONS[value]),
    value,
  }));

  const translatedSelectedOptionLabel = t(MAPPED_TRANSLATION_FILTER_OPTIONS[filterConfig.currentFilter]);

  return (
    <div style={{ width: '100%' }}>
      <ShipmentSelector
        options={translatedFilterOptions}
        value={filterConfig.currentFilter}
        onValueChange={(value) => {
          gtmClickFilter({ filter: value, parcelQty: shipmentsQty ?? 0 });
          updateCurrentFilter(value);
        }}
        renderTrigger={() => <FilterChip label={translatedSelectedOptionLabel} icon={FilterIcon} />}
      />
    </div>
  );
};
